var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"layout-draw"},[_c('el-container',[_c('layout-tools-left',{on:{"changeActiveClassId":_vm.createChat}}),_c('layout-tools-main',{attrs:{"toolId":_vm.toolId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }